import { axiosAjax } from '@app/src/config/axios';
import { PrintPostResponseDTO } from '@app/src/views/StepTwo/channelPublication/dto/PrintDTO';
import { PrintModel } from '@app/src/views/StepTwo/channelPublication/models/print';
import { isClientEnv } from '@app/src/utils/validations';

import { hydrateData } from './hydrators';

export const printService = {
  async post(categoryId: number, json: PrintModel): Promise<PrintPostResponseDTO[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(process.env.API_PRINT.replace(':categoryId', String(categoryId)), hydrateData(json), config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async postPublish(userId: number, categoryId: number, packageId: number, json: PrintModel): Promise<PrintPostResponseDTO[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_PRINT_CONSUME
          .replace(':userId', String(userId))
          .replace(':categoryId', String(categoryId))
          .replace(':packageId', String(packageId)),
        hydrateData(json), config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
};
